import { render } from "./GestionUsuariosView.vue?vue&type=template&id=0fbe31cd&scoped=true"
import script from "./GestionUsuariosView.vue?vue&type=script&lang=js"
export * from "./GestionUsuariosView.vue?vue&type=script&lang=js"

import "./GestionUsuariosView.vue?vue&type=style&index=0&id=0fbe31cd&scoped=true&lang=css"

import exportComponent from "/Users/macbookpro/Documents/Github/sinfoapp/sinfoapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbe31cd"]])

export default __exports__